// @flow

import { RECEIVED_FOOTER_SETTINGS } from './constants';
import type { ReceivedFooterSettings } from './actions';
import type { FooterSettings } from '../../types/settings';

const initialState: FooterSettings = {
  contact_options: [],
  logos: [],
  footer_title: '',
  footer_subtitle: '',
  footer_disclaimer_text: '',
  newsletter: {
    newsletter_title: '',
    newsletter_subtitle: '',
    newsletter_placeholder: '',
    newsletter_button_text: '',
    newsletter_confirmation_title: '',
    newsletter_confirmation_text: '',
    newsletter_error_title: '',
    newsletter_error_text: '',
  },
};

export type State = typeof initialState;

export default (state: State = initialState, action: ReceivedFooterSettings): State => {
  switch (action.type) {
    case RECEIVED_FOOTER_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
